import React from "react"

type T = {
    bgUrl: string 
}

const BackgroundWithImage:  React.FC<T> = (props )=> {

    return (
        <div className="background-with-image" style={{ backgroundImage: `url(${props.bgUrl})` }}>{props.children}</div>
    )
}

export default BackgroundWithImage

